import { render } from "./TButton.vue?vue&type=template&id=90b86a90"
import script from "./TButton.vue?vue&type=script&lang=js"
export * from "./TButton.vue?vue&type=script&lang=js"

import "./TButton.vue?vue&type=style&index=0&id=90b86a90&lang=scss"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__